import axios from "axios";

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

async function logEvent (payload) {
  return await axios.post(`${API_URL}/api/1/logs`, payload);
}

export { logEvent }